import { useModal } from 'components/modals/useModal';
import { CaseStillConfidentialModal } from './CaseStillConfidentialModal';

/** Resolves true on "Close and keep confidential", false on Cancel or when the modal is dismissed. */
export function useConfirmCaseStillConfidential(): () => Promise<boolean> {
    const { openModal, closeModal } = useModal();

    return () =>
        new Promise<boolean>((resolve) => {
            function answer(isConfirmed: boolean) {
                closeModal();
                resolve(isConfirmed);
            }
            openModal(
                <CaseStillConfidentialModal onCancel={() => answer(false)} onConfirm={() => answer(true)} />,
                () => answer(false)
            );
        });
}
